import {Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, Output, ViewChild, DOCUMENT} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ProductSearchPage} from '@spartacus/core';
import {ViewConfig} from '@spartacus/storefront';
import {Subscription} from 'rxjs';

import {AimoProductFacetService} from '../../../service/product/aimo-product-facet.service';
import {AimoProductListComponentService} from '../../../service/product/aimo-product-list-component.service';
import {AimoSpinnerService} from '../spinner/aimo-spinner.service';


@Component({
    selector: 'aimo-cx-page-size',
    templateUrl: './aimo-page-size.component.html',
    standalone: false
})
export class AimoPageSizeComponent implements OnDestroy {
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected router: Router,
        protected viewConfig: ViewConfig,
        protected productListComponentService: AimoProductListComponentService,
        protected spinnerService: AimoSpinnerService,
        protected productFacetService: AimoProductFacetService,
        @Inject(DOCUMENT) protected document: Document,
    ) {
    }

    pageSizes = [20, 50, 100, 500];
    @Input() model: ProductSearchPage;
    @Input() isSelectComponent = true;
    @Input() skipLocationChange = false;
    @Output() pageSizeEvent: EventEmitter<number> = new EventEmitter<number>();

    subscriptions: Subscription = new Subscription();
    @ViewChild('spinnerDiv') divElementRef: ElementRef;

    changeListingItems(): void {
        this.spinnerService.showInnerSpinner(this.divElementRef, null, true);
        this.productListComponentService.getPageItemsForPageSize(
            this.model?.pagination.pageSize,
            this.model?.pagination.currentPage + 1,
        );
        this.productFacetService.setScrollPosition(this.document.defaultView.window.pageYOffset);
    }

    changePageSize(pageSize: number): void {
        this.spinnerService.showInnerSpinner(this.divElementRef, null, true);
        this.pageSizeEvent.emit(pageSize);
        this.productFacetService.setScrollPosition(this.document.defaultView.window.pageYOffset);
    }

    get size(): number {
        if (this.model.products.length < this.model.pagination.pageSize) {
            return this.model.pagination.currentPage * this.model.pagination.pageSize + this.model.products.length;
        }
        return (1 + this.model.pagination.currentPage) * this.model.pagination.pageSize;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
